import { type ColorName } from '@/theme/type'
import { collableTheme } from '@collable/ui'

export const colorNameToHex = (color: ColorName) => {
  if (color in collableTheme.accent)
    return collableTheme.accent[color as keyof typeof collableTheme.accent]

  if (color in collableTheme.background)
    return collableTheme.background[color as keyof typeof collableTheme.background]

  if (color in collableTheme.common)
    return collableTheme.common[color as keyof typeof collableTheme.common]

  if (color in collableTheme.primary)
    return collableTheme.primary[color as keyof typeof collableTheme.primary]

  if (color in collableTheme.label)
    return collableTheme.label[color as keyof typeof collableTheme.label]

  if (color in collableTheme.line)
    return collableTheme.line[color as keyof typeof collableTheme.line]

  if (color in collableTheme.status)
    return collableTheme.status[color as keyof typeof collableTheme.status]

  return collableTheme.fill[color as keyof typeof collableTheme.fill]
}

const hexToRgba = (hex: string, opacity: number): string => {
  const hexColor = hex.replace('#', '')

  const r = parseInt(hexColor.substring(0, 2), 16)
  const g = parseInt(hexColor.substring(2, 4), 16)
  const b = parseInt(hexColor.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export const hexWithOpacity = (
  color:
    | keyof typeof collableTheme.accent
    | keyof typeof collableTheme.background
    | keyof typeof collableTheme.common
    | keyof typeof collableTheme.primary
    | keyof typeof collableTheme.label
    | keyof typeof collableTheme.line
    | keyof typeof collableTheme.status
    | keyof typeof collableTheme.fill,
  opacity: keyof typeof collableTheme.opacity | number,
) => {
  return hexToRgba(
    colorNameToHex(color),
    typeof opacity === 'number' ? opacity : collableTheme.opacity[opacity],
  )
}
